import { getStaticImageUrl } from 'client/utils/image-helpers';
import React from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { EDM_LEASE_DEALS_LOW_INVENTORY_CREATIVE_ID } from 'site-modules/lease-deals/constants/lease-deals-constants';
import { LowInventoryOptions } from 'site-modules/lease-deals/components/low-inventory-options/low-inventory-options';
import { DEALS_FILTER_VALUES } from 'client/site-modules/shared/constants/lease-deals/lease-deals';

import './low-inventory-screen.scss';

export function LowInventoryScreenUI({ selectedFilters = {}, dealsCount = 0, setModelValue }) {
  const title = dealsCount > 0 ? 'Expand your search' : 'No exact matches found';
  const dealType = selectedFilters?.deals?.[0] || DEALS_FILTER_VALUES.ALL;

  return (
    <div
      className="lease-deals-low-inventory-screen-container d-flex justify-content-center"
      data-tracking-parent={EDM_LEASE_DEALS_LOW_INVENTORY_CREATIVE_ID}
    >
      <div className="lease-deals-low-inventory-screen text-cool-gray-10 text-center p-1_5 border rounded-8 bg-cool-gray-90">
        <img
          src={getStaticImageUrl('/img/llm-search.svg')}
          alt="Low inventory logo"
          className="mb-0_5"
          width={204}
          height={120}
        />
        <h3 className="fw-bold">{title}</h3>
        <p>
          We didn’t find {dealsCount > 0 ? 'many' : 'any'}
          {dealType === DEALS_FILTER_VALUES.GEMS ? ' hidden gem' : ''} deals matching your current filters. Try
          adjusting your search to see more results.
        </p>
        <LowInventoryOptions currentTab={dealType} setModelValue={setModelValue} selectedFilters={selectedFilters} />
      </div>
    </div>
  );
}

LowInventoryScreenUI.propTypes = {
  selectedFilters: PropTypes.object,
  dealsCount: PropTypes.number,
  setModelValue: PropTypes.func.isRequired,
};

const stateToPropsConfig = {
  selectedFilters: bindToPath(LeaseDealsPaths.getSelectedFiltersPath(), LeaseDealsModel, null, false),
};

export const LowInventoryScreen = connectToModel(LowInventoryScreenUI, stateToPropsConfig);
